import mapValues from 'lodash/mapValues';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

export default function priceChangedSuccess(state, { choiceDeltas }) {
  const { choices } = state;
  const allChangedChoices = omitBy(mapValues(choiceDeltas, (choice) => {
    const existingChoice = choices[choice.choiceId];
    // update this choice's value
    if (existingChoice) {
      return {
        ...existingChoice,
        pricingQuantity: +choice.pricingQuantity,
        calculatedPrice: choice.calculatedPrice ? choice.calculatedPrice.toFixed(2) : '',
      };
    }
    return undefined;
  }), isNil);

  return {
    ...state,
    choices: {
      ...state.choices,
      ...allChangedChoices,
    },
    ajaxStatus: {
      ...state.ajaxStatus,
      priceCalls: 0,
      priceLoading: false,
    },
  };
}
